export const mapPageTestIDs = {
  mapPage: 'fullscreen_map_page',
  pipWidget: 'map_page_pip_widget',
  changeMapPage: 'change_map_modal_page',
  changeMapPageViewMapButton: 'map_page_change_map_view_map_button',
  changeMapButton: 'map_page_change_map_button',
  changeMapOverlayTypeRadarButton: 'map_page_change_map_overlay_type_radar_button',
  changeMapOverlayTypeFutureRadarButton: 'map_page_change_map_overlay_type_future_radar_button',
  changeMapOverlayTypeLightningButton: 'map_page_change_map_overlay_type_lightning_button',
  changeMapOverlayTypeAlertsButton: 'map_page_change_map_overlay_type_alerts_button',
  changeMapOverlayTypeSatelliteButton: 'map_page_change_map_overlay_type_satellite_button',
  changeMapOverlayTypeTemperatureButton: 'map_page_change_map_overlay_type_temperature_button',
  changeMapOverlayTypeFeelsLikeButton: 'map_page_change_map_overlay_type_feels_like_button',
  changeMapOverlayTypeWindButton: 'map_page_change_map_overlay_type_wind_button',
  changeMapOverlayTypeBreathingIndexButton: 'map_page_change_map_overlay_type_breathing_index_button',
  changeMapZoomLocalButton: 'map_page_change_map_zoom_local_button',
  changeMapZoomRegionalButton: 'map_page_change_map_zoom_regional_button',
  changeMapZoomNationalButton: 'map_page_change_map_zoom_national_button',
  mapLegendSection: 'map_page_legend_section',
  mapLegendBackground: 'map_page_legend_background',
  alertTile: 'map_page_alert_tile',
  alertTilesList: 'map_page_alert_tiles_list',
};
